import React from 'react';
import Navbar from '../../components/Navbar';

const CATALOG = [
  {
    id: 1,
    name: 'Royal Palpali Floral Mandap',
    price: 'NPR 45,000 / setup',
    desc: 'Traditional Palpali wedding mandap decorated with fresh marigolds, red roses, gold velvet drapes, and ceremonial brass oil lamps.',
    tag: 'Palpali Mandap',
    emoji: '🌸'
  },
  {
    id: 2,
    name: 'Yogikuti Grand Stage Backdrop',
    desc: 'Elevated reception stage backdrop featuring crystal chandeliers, royal thrones, LED accent lighting, and white floral arches.',
    price: 'NPR 60,000 / setup',
    tag: 'Stage Backdrop',
    emoji: '🎭'
  },
  {
    id: 3,
    name: 'Fairy Light & Marquee Canopy',
    desc: 'Romantic outdoor marquee tent canopy with warm Edison bulbs, fairy light strings, and full wooden flooring setup.',
    price: 'NPR 28,000 / setup',
    tag: 'Marquee Tent',
    emoji: '✨'
  }
];

export default function Catalog() {
  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Sabitri Mandap Decor & Tent House ✦</span>
          <h1 className="section-title">Mandap Decor & Tent Catalog</h1>
          <p style={{ color: '#6E615E', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Managed by <strong>Krishna Khanal</strong> (9867155395) & Partner <strong>Laxmikant Timilsina</strong> (Office: Yogikuti Chowk, Butwal-10).
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '3.5rem'
        }}>
          {CATALOG.map((item) => (
            <div key={item.id} className="card pillar-card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                  <div style={{ fontSize: '2.5rem' }}>{item.emoji}</div>
                  <span className="badge-light">{item.tag}</span>
                </div>

                <h3 style={{ fontSize: '1.65rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.2rem', fontFamily: 'var(--serif)' }}>
                  {item.name}
                </h3>
                <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#8C6A23', marginBottom: '0.8rem' }}>
                  {item.price}
                </div>
                <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.5rem' }}>
                  {item.desc}
                </p>
              </div>

              <div>
                <a href="tel:9867155395" className="btn btn-primary btn-full">
                  📞 Request Setup with Krishna (9867155395) →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
